// Platform events [02 §17.2]: asynchronous report exports. CR-W2b-12 (CR-W2b-5 R-CORE-1) moved the definition from
// packages/reporting/src/runs/events.ts into the catalogue so the relay validates it like every other event.
import { z } from 'zod';

import { idSchema } from '../kernel/index.ts';
import { defineEvent } from './define.ts';

/** A queued report run; consumed by the worker export consumer (`reports.export-run`). */
export const reportsRunRequestedV1 = defineEvent({
  type: 'reports.run.requested',
  version: 1,
  aggregateType: 'report_run',
  specRefs: ['02 §17.2'],
  payload: z.object({ runId: idSchema }),
});

export const PLATFORM_EVENTS = [reportsRunRequestedV1] as const;
